//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { getPublishersForCreator } from '@apis/universal-image-actions/universalImageActionsApi';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';
import { getClientId } from '@redux/selectors/getClientId';

export const useGetPublishersForCreatorQuery = () => {
  const clientId = useSelector(getClientId);

  return useQuery({
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsProducts,
      QueryKeyConstants.UniversalImageActionsProductsPublishers,
      clientId,
    ],
    queryFn: async ({ signal }) =>
      getPublishersForCreator({ clientId }, { signal }),
    staleTime: FIVE_MINUTES_STALE_TIME,
  });
};
